import { VariationFiltersProvider } from "./variation-filter-provider.service";
import { FilterFactoryCreator, PageKeys } from "@shared";
import { Injectable } from "@angular/core";

@Injectable()
export class PracticeVariationFilterProvider extends VariationFiltersProvider {
    public get pagekey(): string {
        return PageKeys.PRACTICE_VAR_PAGE_KEY;
    }

    protected _defineSpecificFiltersGroups(): // filterFactoryCreator: FilterFactoryCreator<any, {}>,
    // source: (filterName: string) => Observable<any>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    void {}
}
